// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

export type ButtonType = 'primary' | 'secondary' | 'tertiary';
export type ButtonSize = 'default' | 'small';
export type ButtonWidth = 'full' | 'fit';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, SvgIconComponent],
  templateUrl: './button.component.html',
  host: {
    '[style.display]': 'width() === "fit" ? "inline-block" : null',
    '[style.width]': 'width() === "fit" ? "fit-content" : "100%"',
  },
})
export class ButtonComponent {
  // Inputs
  public readonly type = input<ButtonType>('primary');
  public readonly size = input<ButtonSize>('default');
  public readonly disabled = input<boolean>(false);
  public readonly label = input<string>('Button');
  public readonly leftIcon = input<string>();
  public readonly rightIcon = input<string>();
  public readonly width = input<ButtonWidth>('full');

  // Outputs
  public buttonClicked = output<boolean>();

  public onClick(event: MouseEvent): void {
    this.buttonClicked.emit(true);

    requestAnimationFrame(() => {
      (event.currentTarget as HTMLButtonElement | null)?.blur();
    });
  }
}
